import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login/login.service';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  click:any
  popUp:any
  token:any
  storedData:any
  constructor(private router:Router,private loginService:LoginService) { }

  ngOnInit(): void {
    this.token = localStorage.getItem('token');
    this.storedData = JSON.parse(localStorage.getItem("user") || '{}');

  }
  logOut(){
   
    let storedData = JSON.parse(localStorage.getItem("user") || '{}');


let data = {
  "userId": storedData._id || null
};
    this.loginService.logOut(data,this.token).subscribe((response: any) => {
      if (response.status == 1) {

        this.router.navigate(["/login"])



        }
      })



this.router.navigate(["/login"])
  }
  route(){
    if(this.click=='agency'){
      this.router.navigate(["/agency"])

    }
    else if(this.click=='settings'){

      this.router.navigate(["/settings"])

    }
  }

}
